
let imagesApi = {
    async get(type, id, token, companyId, params={}){
        let response = await window.axios.get('/api/images', {
            params:{
                api_token:token,
                company_logged:companyId,
                imageable_type:type,
                imageable_id:id,
                ...params
            }
        });
        return response.data;
    },
}

export default imagesApi